/* istanbul ignore file */
export function getBounds (highways) {
    const allBounds = new window.google.maps.LatLngBounds()
    return highways.reduce((bounds, { path }) =>
        path.reduce((bounds, latLng) => bounds.extend(latLng), bounds)
    , allBounds)
}
